import AnalyticsLogger from '../components/analytics-logger'

export default {

    mixins: [
        AnalyticsLogger,
    ],
}
